import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EPriceAndQualityBalanceActionTypes {
  SetRating = 'NEW_REVIEW/PRICE_AND_QUALITY_BALANCE_RATING/SET',
}

export type TSetPriceAndQualityBalanceRating = ITypedReduxAction<EPriceAndQualityBalanceActionTypes.SetRating, number>;

/**
 * Redux action, который записывает в store общий рейтинг соотношения цены и качества нового отзыва
 * @param rating number
 */
export const setPriceAndQualityBalanceRating: (rating: number) => TSetPriceAndQualityBalanceRating = actionGenerator<
  EPriceAndQualityBalanceActionTypes.SetRating,
  number
>(EPriceAndQualityBalanceActionTypes.SetRating);
